import { SHStack } from "@components/design-systems/sh-stack";
import { Controller, useFormContext } from "react-hook-form";
import { SHRichTextEditor } from "@components/design-systems/sh-rich-text-editor";
import {
  AnalysisSetupDTO,
  AnalysisSetupStepRenderedFieldProps,
} from "@models/platform-analysis/entities/steps/setup";
import { MAX_MEDIUM_TEXT_LENGTH } from "@constants";

export const AnalysisSetupStepObjectivesField = ({
  userType,
  disabled,
}: AnalysisSetupStepRenderedFieldProps) => {
  const { control } = useFormContext<AnalysisSetupDTO>();

  return (
    <SHStack
      spacing={3}
      direction="column"
      sx={{ width: { xs: "100%", md: 520 } }}
    >
      <Controller
        name="objectives"
        control={control}
        render={({ field }) => (
          <SHRichTextEditor
            {...field}
            maxLength={MAX_MEDIUM_TEXT_LENGTH}
            placeHolder={
              userType === "supplier"
                ? "Enter your objectives for this analysis"
                : "Enter your client's situation and needs"
            }
            height={165}
            readOnly={disabled}
          />
        )}
      />
    </SHStack>
  );
};
